export default [
  // *===============================================---*
  // *--------- SIMS -------------------------------------------*
  // *===============================================---*
  {
    path: '/productos-por-caja/:box_id',
    name: 'products-by-box',
    component: () => import('@/views/boxes/products/ProductsBox.vue'),
  },
]